import InstagramFeed from '../../components/InstagramFeed'
import '../../components/InstagramFeed/styles.module.css'

import './styles.css'

// https://www.npmjs.com/package/react-ig-feed
// https://mohammedraji.github.io/posts/get-instagram-graph-API/

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <div className='container portfolio__container'>
        <InstagramFeed token="EABGUZBwkkKwMBPCXf3eBO5lNuJ5uAkYlmorsmUVw1vkaKcUIiQTuw7WZCWxvdgf3ZBYWfukOkagVJVaf9ZACiLck6acZAA94w6cgYbvqzNY1ApHKvKD7WPGfM1H6MsgFZAu2hDwZBgwEGLgcz5tekZCexCI6JpTdP82d16PUUH1e5lOfDenONO9lt0xEuQnieU4S1lMEXBSF4XimQ36yb7EORGVXcLAuUrZBbbfaS" />
      </div>
    </section>
  )
}

export default Portfolio
